export const constant = {
  tokenName: "SBG-WEB",
  expiryName: "SBG-EXP",
  profileName: "SBG-PRF",
  baseUrl: "https://sabigift-api.herokuapp.com/api"
}
